import { Component, Input } from '@angular/core';
import { SlideDTO } from 'src/app/model/slideDTO.model';

@Component({
    selector: 'app-slide-spacer',
    templateUrl: './slide-spacer.component.html',
    styleUrls: ['./slide-spacer.component.scss'],
    standalone: false
})
export class SlideSpacerComponent {
  @Input() public slideData: SlideDTO;
}
